import styled from 'styled-components'
import { device } from '../../../../theme'

export const SectionWrap = styled.div`
    padding-bottom: 56px;
    @media ${device.medium}{
        padding-bottom: 35px;
    }
`;